<template>
  <div class="aansluitingen pt-12">
    <v-container fluid class="grey darken-3 recolor" py-0 :class="[$vuetify.breakpoint.mdAndUp ? '' : '']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? 'px-8' : 'px-0 pb-0']">
        <v-layout
          align-center
          fill-height
          row 
          wrap
          :class="[$vuetify.breakpoint.mdAndUp ? 'pt-12 mt-8' : '']"
        >
          <v-flex xs12 class="d-flex h-100">
            <v-container fluid :class="[$vuetify.breakpoint.mdAndUp ? '' : 'pb-2']">
              <v-layout row wrap align-stretch :class="[$vuetify.breakpoint.mdAndUp ? 'py-6' : 'pt-6 pb-0']">
                <v-flex  xs12 md6 lg8 ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? 'pr-8 ' : 'mb-10']">
                  <v-card height="100%" color="grey darken-4 recolor" class="elevation-0" :class="[$vuetify.breakpoint.mdAndDown ? 'px-4 py-6' : 'px-4 py-5', $vuetify.breakpoint.smAndDown ? '' : 'bor-white']">
                    <v-container fluid py-0 ma-0 fill-height>
                      <v-layout row wrap  fill-height >
                        <v-flex xs12 lg6 :class="[$vuetify.breakpoint.mdAndDown ? '' : '']">
                          <div class="d-flex align-content-space-between flex-wrap fill-height">
                            <v-container fluid py-0 mb-auto>
                              <v-layout row wrap py-0 :class="[$vuetify.breakpoint.mdAndDown ? 'pt-4 text-center' : '']">
                                <v-flex xs12>
                                  <span class="headline">Aanvraagstatus</span>
                                   <v-card height="100%" color="transparent" class="elevation-0" v-if="$vuetify.breakpoint.lgAndUp">
                                    <v-container fluid fill-height pt-4 pb-2>
                                      <v-layout row wrap justify-end >
                                        <v-flex xs12 md12  py-0  class=" white--text position-relative">
                                          <v-container fluid py-0>
                                            <v-layout row wrap>
                                              <v-flex xs12 pr-2>
                                                <v-item-group mandatory v-model="dataStatusModel" class="">
                                                  <v-container fluid class="">
                                                    <v-row>
                                                      <v-col
                                                        v-for="(item, i) in dataStatus"
                                                        :key="i"
                                                        cols="12"
                                                        md="12"
                                                        class="pa-0"
                                                      >
                                                        <v-item v-slot:default="{ active, toggle }">
                                                          <v-hover v-slot:default="{ hover }">
                                                          <v-card
                                                            :color="active ? 'grey darken-3 recolor' : ''"
                                                            class="d-flex align-center energy-dates"
                                                            dark
                                                            height="40"
                                                            @click="toggle(); selected(i);"
                                                            tile
                                                            :elevation="hover ? 2 : 0"
                                                            :class="{ 'on-hover': hover }"
                                                          > 
                                                            <v-container fluid grid-list-lg>
                                                              <v-layout row wrap align-center justify-end fill-height :class="['weekday-'+i]">
                                                                <v-flex xs12 sm6>
                                                                   {{ toShortFullDate(item.date) }}
                                                                </v-flex>
                                                                <v-flex xs12 sm6>
                                                                  <v-card height="20" class="elevation-0 tile head-graph ma-0" color="transparent" :class="[$vuetify.breakpoint.xsOnly ? 'pl-1' : '']">
                                                                     <bars-chart v-bind:data="item" style="border: 1px solid white; border-radius: 4px !important; padding: 2px;" class=""></bars-chart>
                                                                  </v-card>
                                                                </v-flex>
                                                              </v-layout>
                                                            </v-container>
                                                            <v-scroll-y-transition class="position-absolute">
                                                              <div
                                                                v-if="active"
                                                                class=" flex-grow-1 h-100 text-center position-relative "
                                                                :class="[$vuetify.breakpoint.xlOnly ? 'has-triangle triangle1 tri-small' : '']"
                                                              ></div>
                                                            </v-scroll-y-transition>
                                                          </v-card>
                                                          </v-hover>
                                                        </v-item>
                                                      </v-col>
                                                    </v-row>
                                                  </v-container>
                                                </v-item-group>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                          <v-container fluid py-0 px-3  :class="[$vuetify.breakpoint.smAndDown ? 'pt-0 pb-2' : '']">
                                            <v-layout row wrap  justify-end :class="[$vuetify.breakpoint.mdAndDown ? 'px-2' : 'pr-1', $vuetify.breakpoint.lgAndUp ? '' : '']" >
                                              <v-flex xs12    class=" white--text position-relative">
                                                <v-container fluid py-0 px-5>
                                                  <v-layout row wrap  pr-1 fill-height >
                                                    <v-flex xs6 sm5>
                                                      <a class="d-block dashboard-pager" v-bind:class="{ 'can-press': current }" @click="switchStates(false)">< vorige week</a>
                                                    </v-flex>
                                                    <v-flex xs6 sm7>
                                                      <v-layout row wrap justify-end pr-4>
                                                        <a  class="d-block dashboard-pager" v-bind:class="{ 'can-press': !current }" @click="switchStates(true)">huidige week ></a>
                                                      </v-layout>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-container>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-container> 
                          </div>
                        </v-flex>
                        <v-flex xs12 lg6 :class="[$vuetify.breakpoint.xlOnly ? 'pl-5' : '']">
                          <v-card  class=" elevation-0 mb-2 grey darken-3 recolor px-2 bp-3">
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neg d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.errors.request) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [3]}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.errors.request }} foutmeldingen ontvangen
                                            </span>
                                            <v-icon class="ml-auto " >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neg d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.errors.end) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [6]}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.errors.end }} x zal niet meer komen
                                            </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neg d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.errors.malfunction) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [3]}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.errors.malfunction }} fouten door storingen
                                            </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-neutral d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.errors.new) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [1]}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.errors.new }} nog niet aangevraagd
                                            </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                          <v-card  class=" elevation-0 mb-2 grey darken-3 recolor px-2 pb-3">
                            <v-container fluid pb-0>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half orange d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.reask) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [4]}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.reask }} Data opnieuw aangevraagd
                                            </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                            <v-container fluid>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-pos2 d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.expected) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height>
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [2]}, true)">
                                            <span class="mr-2">
                                              {{ selectedDataStatus.expected }} Data in aanvraag
                                            </span>
                                            <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                          <v-card  class=" elevation-0 grey darken-3 recolor px-2 pb-3">
                            <v-container fluid>
                              <v-layout row wrap>
                                <v-flex xs4 sm6 md3>
                                  <div class="percentage-box half stat-pos1 d-flex align-center justify-center" :class="{'auto-stat' : $vuetify.breakpoint.smAndDown }">
                                    <span>{{ formatNumber(((selectedDataStatus.recieved) / (selectedDataStatus.total != 0 ? selectedDataStatus.total : 1)) * 100, 2) }}%</span>
                                  </div>
                                </v-flex>
                                <v-flex xs8 sm6 md9 pl-5>
                                  <v-container fluid pa-0 ma-0>
                                    <v-layout row wrap align-center fill-height py-0 pr-3>
                                      <v-flex xs12 class="bot-bor-white pb-2">
                                        <v-container fluid py-0>
                                          <v-layout row wrap align-center fill-height >
                                            <a class="w-100 d-flex stat-link" @click="filter({state: [5]}, true)">
                                              <span class="mr-2">
                                                {{ selectedDataStatus.recieved }} Data ontvangen
                                              </span>
                                              <v-icon class="ml-auto" >fas fa-chevron-right</v-icon>
                                            </a>
                                          </v-layout>
                                        </v-container>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 class=" white--text position-relative mt-6" v-if="$vuetify.breakpoint.mdAndDown">
                          <v-container fluid py-0 >
                            <v-layout row wrap fill-height >
                              <v-flex xs6 sm5>
                                <a class="d-block dashboard-pager can-press">< vorige week</a>
                              </v-flex>
                              <v-flex xs6 sm7>
                                <v-layout row wrap justify-end pr-4>
                                  <a class="d-block dashboard-pager">huidige week ></a>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
                <v-flex  xs12 md6 lg4  ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? ' ' : 'mb-8']">
                  <v-card height="100%" color="grey darken-4 recolor" class="elevation-0" :class="[$vuetify.breakpoint.mdAndDown ? 'px-4 py-6' : 'px-4 py-5', $vuetify.breakpoint.smAndDown ? '' : 'bor-white']">
                    <v-container fluid py-0 ma-0 fill-height>
                      <v-layout row wrap  fill-height >
                        <v-flex xs12 :class="[$vuetify.breakpoint.mdAndDown ? '' : '']">
                          <div class="d-flex ">
                            <v-container fluid py-0 mb-auto>
                              <v-layout row wrap py-0 :class="[$vuetify.breakpoint.mdAndDown ? 'pt-4 text-center' : '']">
                                <v-flex xs12>
                                  <span class="headline">Status per netbeheerder</span>
                                    <v-item-group mandatory class="">
                                      <v-container fluid py-6 class="">
                                        <v-row class="">
                                          <v-col
                                            v-for="(item, i) in netbeheerderStatus"
                                            :key="i"
                                            cols="12"
                                            md="12"
                                            class="pa-0"
                                          >
                                            <v-item>
                                                <v-hover v-slot:default="{ hover }">
                                                <v-card
                                                  class="d-flex align-center energy-dates pa-0"
                                                  dark
                                                  :height="$vuetify.breakpoint.xsOnly ? 'auto' : '40'"
                                                  tile
                                                  :elevation="hover ? 2 : 0"
                                                  :class="{ 'on-hover': hover }"
                                                   @click="filter({gridoperator:item.id}, true)"
                                                > 
                                                  <v-container fluid grid-list-lg :class="[$vuetify.breakpoint.smAndDown ? 'px-2' : '']">
                                                    <v-layout row wrap align-center justify-end fill-height :class="['weekday-'+i]">
                                                      <v-flex xs12 sm6 justify-start class="text-left" :class="[$vuetify.breakpoint.smAndUp ? ' ' : 'py-0']">
                                                        <span>{{ item.name }}</span>
                                                      </v-flex>
                                                      <v-flex xs12 sm6>

                                                        <v-card height="20" class="elevation-0 tile head-graph ma-0 pr-5 d-flex" color="transparent" :class="[$vuetify.breakpoint.xsOnly ? 'pl-1' : '']">
                                                          <bars-chart v-bind:data="item" style="border: 1px solid white; border-radius: 4px !important; padding: 2px;" class=""></bars-chart>
                                                          <v-icon class="small-icon pl-2">fas fa-chevron-right</v-icon>
                                                        </v-card>
                                                     
                                                          
                                                
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-container>
                                                </v-card>
                                                </v-hover>
                                            </v-item>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-item-group>
                                </v-flex>
                              </v-layout>
                            </v-container> 
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <v-container fluid black :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'px-0']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-0']">
        <v-layout row wrap :class="[$vuetify.breakpoint.mdAndUp ? 'px-4' : 'px-3']">
          <v-flex xs12>
            <s-card>
              <v-card-title class="px-0 white--text">
                {{ pageContent.pageSub2 }}
                <v-btn @click="expectsFilter = true" icon small class="ml-2"> <v-icon>filter_list</v-icon> </v-btn>
              </v-card-title>
              <v-data-table dark
                :headers="headers"
                :items="expects"
                :server-items-length="expectsTotal"
                :options.sync="expectsOptions"
                :items-per-page="25"
                :loading="loadingExpects"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :footer-props="{ itemsPerPageOptions: [25,50,75,100], itemsPerPageText: 'Rijen per pagina' }"
                :class="[$vuetify.breakpoint.smAndUp ? 'white-borders' : 'mobile-table']"
                dense
                loading-text="laden..."
                no-results-text="geen aanvragen beschikbaar"
                no-data-text="geen aanvragen beschikbaar"
                id="requestTable"
              >
                <template v-slot:item.state="{ item }">
                  <span class="text-no-wrap d-flex">
                    <span class="white--text no-dec mr-2"> 

                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="item.state_color"></div>
                      </div>
                      {{ item.state }}</span>
                  </span>
                </template>
                <template v-slot:item.requested="{ item }">
                  <span class="text-no-wrap d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']" v-if="item.state_filter != undefined" @click="goto(item.state_filter)">
                    <a class="white--text no-dec mr-2">{{ item.requested == null || item.requested == '' ? '' : toShortDate(item.requested)}}</a>
                    <v-icon class="ml-auto small-icon">fas fa-chevron-right</v-icon>
                  </span>
                  <span class="text-no-wrap d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']" v-if="item.state_filter == undefined">
                    {{ item.requested == null || item.requested == '' ? '' : toShortDate(item.requested)}}
                  </span>
                </template>
                <template v-slot:item.number="{ item }">
                  <span class="text-no-wrap d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']" @click="toConnections({ean:item.ean})">
                    <a class="white--text no-dec mr-2">{{ item.number }}</a>
                    <v-icon class="ml-auto small-icon cursor-pointer">fas fa-chevron-right</v-icon>
                  </span>
                </template>
                <template v-slot:item.date="{ item }">
                 {{ item.date == null ? '' : toShortDate(item.date)}}
                </template>
                <template v-slot:item.gridoperator="{ item }">
                  <span class="text-no-wrap w-100 d-block">
                    <a class="white--text no-dec d-flex" @click="selectdOperator(item)">
                      <span>{{ item.gridoperator.name }}</span>
                      <v-spacer></v-spacer>
                      <v-icon class="ml-auto small-icon" v-if="item.gridoperator.name != ''">fas fa-chevron-right</v-icon>
                    </a>
                  </span>
                </template>
              </v-data-table>
            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
   <filters title="filter aanvragen" :open.sync="expectsFilter" :options="expectsFilterOptions" :values="expectsOptions.filters" @filter="filter"></filters>
   <operator :operator="selectedOperator" v-bind:dialog.sync="operatorDialog"></operator>
  </div>
</template>

<script>

import PieChart from '@/components/PieChart';
import BarsChart from '@/components/BarsChart';
import Operator from '@/components/Operator';
import Filters from '@/components/Filters';

export default {

  name: 'aansluitingen',
  components: { PieChart, BarsChart, Operator, Filters },
  data() {
    return {
      current: true,
      stateLoading: false,
      dataStatusModel: 6,
      selectedDataStatus:{date: "", errors: {request: 0, malfunction: 0, new: 0}, expected: 0, recieved: 0, reask: 0, total: 0},
      dataStatus:[],
      netbeheerderStatus: [ ],
      operatorLoading: false,
      selectedOperator:{},
      operatorDialog: false,
      headers: [
        { text: 'Status', value: 'state', align: 'left',},
        { text: 'Data datum', value: 'date', align: 'left',},
        { text: 'Aanvraagdatum', value: 'requested', align: 'left',},
        { text: 'EAN', value: 'ean', align: 'left',},
        { text: 'Type', value: 'type', align: 'left',},
        { text: 'Netbeheerder', value: 'gridoperator', align: 'left',},
        { text: 'Interval', value: 'reason', align: 'left',},
        { text: 'Postcode', value: 'postal', align: 'left',},
        { text: 'Huisnr', value: 'number', align: 'left',},
        { text: 'Meterstatus', value: 'meterstate', align: 'left', sortable: false},
      ],
      expects: [],
      expectsTotal:0,
      loadingExpects: false,
      expectsFilter: false,
      search:[],
      pageContent: {
        pageTitle: 'Aansluiting overzicht',
        pageSub1: 'Alle aansluitingen',
        pageSub2: 'Aanvragen',
      },
      expectsFilterOptions:{
        state:{type:'multiselect', label:'aanvraag status', options:[
            { text: 'allemaal', value: null}, 
            { text: 'nog niet aangevraagd', value: 1}, 
            { text: 'aangevraagd', value: 2}, 
            { text: 'fout melding', value: 3}, 
            { text: 'wordt opnieuw aangevraagd', value: 4}, 
            { text: 'ontvangen', value: 5}, 
            { text: 'te oud', value: 6}, 
            { text: 'versturen', value: 7}, 
          ]
        },
        date:{type:'date', label:'data datum'},
        requested:{type:'date', label:'aanvraagdatum'},
        ean:{type:'text', label:'ean', placeholder:'123456789012345678'},
        type:{type:'select', label:'type', options:[{ text: 'allemaal', value: null}, { text: 'elektriciteit', value: 1}, { text: 'gas', value: 3}, { text: 'teruglevering', value: 2}]},
        gridoperator:{type:'select', label:'netbeheerder', options:this.$store.state.operators},
        interval:{type:'select', label:'interval', options:[{ text: 'allemaal', value: null}, { text: 'kwartier', value: 1}, { text: 'dag', value: 2}, { text: 'maand', value: 3}]},
        postal:{type:'text', label:'postcode', placeholder:'1234AB'},
        number:{type:'text', label:'huisnummer', placeholder:'1'},
      },
      filters:{},
    };
  },
  mounted()
  {
    this.loadStates();
  },
  methods: {
    filter(filters, scrollTo)
    {
      console.log(filters);
      let temp = JSON.parse(JSON.stringify(this.expectsOptions));
      temp.filters = filters;
      temp.page = 1;
      this.expectsOptions = JSON.parse(JSON.stringify(temp));
      if(scrollTo === true)
      {
        this.$vuetify.goTo('table');
      }
    },
    loadStates()
    {
      this.stateLoading = true;

      this.dataStatus = [];
      let start = new Date();
      let end = new Date();
      if(this.current)
      {
        start.setDate(start.getDate() - 7);
        end.setDate(end.getDate() - 1);
      }
      else
      {
        start.setDate(start.getDate() - 14);
        end.setDate(end.getDate() - 8);
      }
      let data = 
      {
        start:start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate(),
        end:end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate(),
      };
      this.$store.dispatch('loadDataExpendedState', data).then
      ((data) => {
        this.dataStatusModel = 6;
        this.dataStatus = data.data;
        this.stateLoading = false;
        this.selected(this.dataStatusModel);
      });
    },
    selected(selected)
    {
        this.selectedDataStatus = this.dataStatus[selected];
        this.selectedDataStatus.total = 
          this.selectedDataStatus.errors.request
           + this.selectedDataStatus.errors.malfunction
           + this.selectedDataStatus.errors.new
           + this.selectedDataStatus.expected
           + this.selectedDataStatus.recieved
           + this.selectedDataStatus.reask;
      this.loadOperator(this.selectedDataStatus.date);
    },
    switchStates(current)
    {
      this.current = current;
      this.loadStates();
    },
    loadOperator(date)
    {
      this.operatorLoading = true;
      let data = {start:date, end:date};
      this.netbeheerderStatus = [];
      this.$store.dispatch('loadDataStateOperators', data).then
      ((data) => {
        this.netbeheerderStatus = data.data;
        this.operatorLoading = false;
      });
    },
    loadExpects()
    {
      this.loadingExpects = true;
      this.$store.dispatch('loadExpects', this.expectsOptions).then
      ((data) => {
        this.expectsTotal = data.recordsTotal;
        this.expects = data.data;
        this.loadingExpects = false;
      });
    },
    goto(filter)
    {
      switch(filter.page)
      {
        case 'errors':
          this.toErrors(filter.filter);
        break;
      }
    },
    selectdOperator(operator)
    {
      this.selectedOperator = operator.gridoperator;
      this.operatorDialog = true;
    },
 },
  computed: {
    expectsOptions: {
        get: function()
        {
          return this.$store.state.expectsOptions;
        },
        set: function(value)
        {
          this.$store.state.expectsOptions = value;
        }
    },
    permissions : {
      get() {
        return this.$store.getters.permissions;
      }
    }
  },
  watch:
  {
    expectsOptions: {
      deep:true,
          handler (newState, old) {
           this.loadExpects();
      }
    }
	},

};

</script>

<style scoped>

.v-card.energy-dates {
    -moz-transition: all 200ms ease-in;
    -webkit-transition: all 200ms ease-in;
    -o-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
}

.v-card.energy-dates:not(.on-hover):not(.v-item--active){
  background: #141414;
 }

.v-card.v-card--link:before{
  background: none;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>